import { FollowUpWorkStatus } from '@nkr/enums/follow-up-work-status';
import { IFollowUpSurvey } from '@nkr/models/follow-up';
import { Panel } from 'react-bootstrap';
import { PanelBodyWrapper } from '../../styles';
import helpers from './helpers';

const PreviousDetails = (props: { data: IFollowUpSurvey, previous: IFollowUpSurvey }) => {
    let bmiClass = helpers.comparePrevious(props.previous.bmi, props.data.bmi, true);

    return (
        <Panel>
            <Panel.Heading>Survey Details</Panel.Heading>
            <PanelBodyWrapper>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-xs-3'></div>
                        <div className='col-xs-4 col-xs-offset-1'><h4 className='text-center'>{props.previous.surveyInstance} Survey</h4></div>
                        <div className='col-xs-4'><h4 className='text-center'>{props.data.surveyInstance} Survey</h4></div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Weight:</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.weightLbs} lbs</div>
                        <div className='col-xs-4 text-center'>{props.data.weightLbs} lbs</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>BMI:</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.bmi}</div>
                        <div className='col-xs-4 text-center'><span className={bmiClass} style={{ display: 'inline' }}>{props.data.bmi}</span></div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Last seen by physician:</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.lastSeenByPhysician}</div>
                        <div className='col-xs-4 text-center'>{props.data.lastSeenByPhysician}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has high blood pressure?:</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.hasHighBp)}</div>
                        <div className='col-xs-4 text-center'>{helpers.getBool(props.data.hasHighBp)}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Blood Pressure:</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.bpSystolic != null ? props.previous.bpSystolic : '[not answered]'}/{props.previous.bpDiastolic != null ? props.previous.bpDiastolic : '[not answered]'}</div>
                        <div className='col-xs-4 text-center'>{props.data.bpSystolic}/{props.data.bpDiastolic}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has diabetes?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.hasDiabetes)}</div>
                        <div className='col-xs-4 text-center'>{helpers.getBool(props.data.hasDiabetes)}</div>
                    </div>

                    {props.data.hasDiabetes && props.data.diabeticUsesInsulin && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>&nbsp; - BG maintained by insulin:</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.diabeticUsesInsulin)}</div>
                            <div className='col-xs-4 text-center'>{helpers.getBool(props.data.diabeticUsesInsulin)}</div>
                        </div>
                    )}

                    {props.data.hasDiabetes && props.data.diabeticUsesOralMeds && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>&nbsp; - BG maintained by oral meds:</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.diabeticUsesOralMeds)}</div>
                            <div className='col-xs-4 text-center'>{helpers.getBool(props.data.diabeticUsesOralMeds)}</div>
                        </div>
                    )}

                    {props.data.hasDiabetes && props.data.diabeticUsesDiet && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong> &nbsp; - BG maintained by diet/exercise:</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.diabeticUsesDiet)}</div>
                            <div className='col-xs-4 text-center'>{helpers.getBool(props.data.diabeticUsesDiet)}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has had complications?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.hadOtherComplications)}</div>
                        <div className='col-xs-4 text-center'>{helpers.getBool(props.data.hadOtherComplications)}</div>
                    </div>

                    {(props.previous.hadOtherComplications || props.data.hadOtherComplications) && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.otherComplicationDescription == '' ? '[no comments]' : props.previous.otherComplicationDescription}</div>
                            <div className='col-xs-4 text-center'>{props.data.otherComplicationDescription == '' ? '[no comments]' : props.data.otherComplicationDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Required Urgent Care?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.hadUrgentCare)}</div>
                        <div className='col-xs-4 text-center'>{helpers.getBool(props.data.hadUrgentCare)}</div>
                    </div>

                    {(props.previous.hadUrgentCare || props.data.hadUrgentCare) && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.urgentCareDescription == '' ? '[no comments]' : props.previous.urgentCareDescription}</div>
                            <div className='col-xs-4 text-center'>{props.data.urgentCareDescription == '' ? '[no comments]' : props.data.urgentCareDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Physical Capacity?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.physicalCapacity != '' ? props.previous.physicalCapacity : '[not answered]'}</div>
                        <div className='col-xs-4 text-center'>{props.data.physicalCapacity != '' ? props.data.physicalCapacity : '[not answered]'}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Percent Functional?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>
                            {helpers.getText(props.previous.percentFunctional, props.previous.percentFunctional < 100, '%')}
                        </div>
                        <div className='col-xs-4 text-center'>
                            {helpers.getText(props.data.percentFunctional, props.data.percentFunctional < 100, '%')}
                        </div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has Regrets?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.hasRegrets)}</div>
                        <div className='col-xs-4 text-center'>{helpers.getBool(props.data.hasRegrets)}</div>
                    </div>

                    {(props.previous.hasRegrets || props.data.hasRegrets) && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.regretsDescription != '' ? '[no comments]' : props.previous.regretsDescription}</div>
                            <div className='col-xs-4 text-center'>{props.data.regretsDescription != '' ? '[no comments]' : props.data.regretsDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Work Status?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>
                            {helpers.getText(props.data.workStatus, props.previous.workStatusId != FollowUpWorkStatus.FullTime, '')}
                        </div>
                        <div className='col-xs-4 text-center'>
                            {helpers.getText(props.data.workStatus, props.data.workStatusId != FollowUpWorkStatus.FullTime, '')}
                        </div>
                    </div>

                    {(props.previous.workStatusId != FollowUpWorkStatus.FullTime || props.data.workStatusId != FollowUpWorkStatus.FullTime) && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>Reason not working full-time?</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.outOfWorkReason}</div>
                            <div className='col-xs-4 text-center'>{props.data.outOfWorkReason}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has lost insurance?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.hasLostInsurance)}</div>
                        <div className='col-xs-4 text-center'>{helpers.getBool(props.data.hasLostInsurance)}</div>
                    </div>

                    {(props.previous.hasLostInsurance || props.data.hasLostInsurance) && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Reason</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.lostInsuranceDescription == '' ? '[no comments]' : props.previous.lostInsuranceDescription}</div>
                            <div className='col-xs-4 text-center'>{props.data.lostInsuranceDescription == '' ? '[no comments]' : props.data.lostInsuranceDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has started dialysis?</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{helpers.getBool(props.previous.hasStartedDialysis)}</div>
                        <div className='col-xs-4 text-center'>{helpers.getBool(props.data.hasStartedDialysis)}</div>
                    </div>

                    {(props.previous.hasStartedDialysis || props.data.hasStartedDialysis) && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.startedDialysisDescription == '' ? '[no comments]' : props.previous.startedDialysisDescription}</div>
                            <div className='col-xs-4 text-center'>{props.data.startedDialysisDescription == '' ? '[no comments]' : props.data.startedDialysisDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Additional Comments</strong></div>
                        <div className='col-xs-4 col-xs-offset-1 text-center'>{props.previous.startedDialysisDescription == '' ? '[no comments]' : props.previous.startedDialysisDescription}</div>
                        <div className='col-xs-4 text-center'>{props.data.startedDialysisDescription == '' ? '[no comments]' : props.data.startedDialysisDescription}</div>
                    </div>
                </div>
            </PanelBodyWrapper>
        </Panel>
    )
}

export default PreviousDetails;